import request from '@/api/request'
import type { BillRow, SpringPage } from '@/api/types/domain'

export function fetchBills(params: { keyword?: string; page?: number; rows?: number }) {
  return request.get<SpringPage<BillRow>>('/api/admin/backoffice/bills', { params })
}

export function deleteBill(id: number) {
  return request.delete(`/api/admin/backoffice/bills/${id}`)
}
